"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendDatahub = exports.REVALIDATE_REASON = exports.LOGOUT_REASON = exports.EVENT_SYSTEM = exports.EVENT_ENTITY = exports.EVENT_ACTION = void 0;
const event_agent_js_1 = __importDefault(require("@hotmart/event-agent-js"));
const env_1 = require("./env");
var EVENT_ACTION;
(function (EVENT_ACTION) {
    EVENT_ACTION["SEND"] = "send";
})(EVENT_ACTION || (EVENT_ACTION = {}));
exports.EVENT_ACTION = EVENT_ACTION;
var EVENT_ENTITY;
(function (EVENT_ENTITY) {
    EVENT_ENTITY["LOGOUT"] = "logout";
    EVENT_ENTITY["RENEW"] = "renew";
    EVENT_ENTITY["REVALIDATE"] = "revalidate";
})(EVENT_ENTITY || (EVENT_ENTITY = {}));
exports.EVENT_ENTITY = EVENT_ENTITY;
const EVENT_SYSTEM = 'cas-js';
exports.EVENT_SYSTEM = EVENT_SYSTEM;
var LOGOUT_REASON;
(function (LOGOUT_REASON) {
    LOGOUT_REASON["API_ERROR"] = "api_error";
    LOGOUT_REASON["RENEW_ERROR"] = "renew_error";
    LOGOUT_REASON["USER"] = "user";
})(LOGOUT_REASON || (LOGOUT_REASON = {}));
exports.LOGOUT_REASON = LOGOUT_REASON;
var REVALIDATE_REASON;
(function (REVALIDATE_REASON) {
    REVALIDATE_REASON["FOCUS"] = "focus";
    REVALIDATE_REASON["LOGOUT"] = "logout";
    REVALIDATE_REASON["START"] = "start";
})(REVALIDATE_REASON || (REVALIDATE_REASON = {}));
exports.REVALIDATE_REASON = REVALIDATE_REASON;
event_agent_js_1.default.mode = env_1.isProd ? 'production' : 'staging';
const sendDatahub = (entity, event, action = EVENT_ACTION.SEND) => {
    const data = { system: EVENT_SYSTEM, action, entity, event };
    if (env_1.isLocal) {
        localStorage.setItem(`cas-js:event:${Date.now()}`, JSON.stringify(data));
        console.info(data);
        return;
    }
    try {
        event_agent_js_1.default.send(data);
    }
    catch (error) {
        console.error(error);
    }
};
exports.sendDatahub = sendDatahub;



//////////////////
// WEBPACK FOOTER
// ./~/@hotmart/cas-js/dist/utils/event.agent.js
// module id = 208
// module chunks = 0